import React from 'react'
import { Button, Typography } from '@mui/material';

const Top = () => {
  return (
    <div>
        <header className="header">

<div className="background">
  <div className="body">
    <Typography color='primary' variant='p' >
      BILLIONAIRE <br/> MINDSET
    </Typography>
    
    <h2 className="heading">
      Top-notch Crypto <br/>Services
    </h2>
    <p className="text1">
      We take pride in helping people from all walks of life achieve their set goals in the crypto industry. Hire us for the best services in the crypto industry.
    </p>

    <Button 
    variant='contained'
    color='secondary'
    href='https://t.me/yalex1262'
    >
      CONTACT US
    </Button>

    <p className='yalex' dir='rtl'> yalexworld</p>
  </div>
</div>

</header>
    </div>
  )
}

export default Top